import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
    selector: 'app-agent-info-popup',
    templateUrl: './agent-info-popup.component.html',
    standalone: false
})
export class AgentInfoPopupComponent {
  bookingNo!: string;
  agents: any;
  constructor(
    public dialogRef: MatDialogRef<AgentInfoPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.bookingNo = this.data.bookingNo;
    this.agents = this.data.agents;
  }
}
